/**
 * Skeleton dos Orçamentos — header padrão + filtros + lista.
 */
export default function Loading() {
  return (
    <div className="mx-auto flex max-w-5xl animate-pulse flex-col gap-6">
      {/* PageHeader */}
      <div className="h-[104px] rounded-[20px] bg-slate-200" />

      <div className="flex flex-col gap-4">
        <div className="flex items-center justify-between">
          <div className="flex gap-1.5">
            {[0, 1, 2, 3].map((c) => (
              <div key={c} className="h-7 w-20 rounded-full bg-slate-100" />
            ))}
          </div>
          <div className="h-8 w-36 rounded-lg bg-slate-100" />
        </div>

        <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
          {[0, 1, 2, 3].map((r) => (
            <div
              key={r}
              className="flex items-center justify-between border-b border-slate-100 px-4 py-3 last:border-0"
            >
              <div className="space-y-1.5">
                <div className="h-4 w-44 rounded bg-slate-200" />
                <div className="h-3 w-32 rounded bg-slate-100" />
              </div>
              <div className="flex items-center gap-3">
                <div className="h-4 w-20 rounded bg-slate-200" />
                <div className="h-5 w-16 rounded-full bg-slate-100" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
